const API_URL = "https://api.c3fitnesssciencegymgmail.com/api";
// const API_URL = "http://localhost:8080/api";

export default API_URL;
